module.exports = {
    SCROLL_PAN: 'SCROLL_PAN',
    MOUSE_PAN: 'MOUSE_PAN',
    TOUCH_PAN: 'TOUCH_PAN',
    KEYBOARD_PAN: 'KEYBOARD_PAN',
    PINCH: 'PINCH',
    SPREAD: 'SPREAD',
    DOUBLE_CLICK: 'DOUBLE_CLICK',
    OTHERS: 'OTHERS',
};
